RCDPW.module('RCDPW.modal', function () {

    var modalIndex = 0;

    /**
     * Modal constructor.
     *
     * @constructor
     */
    function Modal() {
        var $root = generateRoot();
        this.$root = $root;
        this.$typeContainer = $root.find('>div');
        this.$okBtn = $root.find('.modal-ok-btn');
        this.$okBtnText = $root.find('.modal-ok-btn-text');
        this.$closeBtn = $root.find('.modal-dismiss');
        this.$titleEl = $root.find('.modal-title');
        this.$subTitleEl = $root.find('.modal-sub-title');
        this.$contentEl = $root.find('.modal-content');
        this.$footerEl = $root.find('.modal-footer');
        this.previousActiveElement = null;

        function generateRoot() {
            var defaultModalId = '#modal';
            var $root = $(defaultModalId).clone();

            $root.attr('id', defaultModalId.substring(1) + '-DPW-' + modalIndex);
            $(document.body).append($root);

            modalIndex++;

            return $root;
        }
    }

    /**
     * Add custom classes to modal.
     *
     * @param {String} className - the class name to add.
     */
    Modal.prototype.addClass = function (className) {
        this.$root.addClass(className);
        return this;
    };

    /**
     * Destroy the modal and remove relative DOM.
     */
    Modal.prototype.destroy = function () {
        this.$root.remove();
        return this;
    };

    /**
     * Show modal.
     */
    Modal.prototype.show = function () {
        this.previousActiveElement = document.activeElement;
        var isDocumentBody = this.previousActiveElement == document.body;
        if (!isDocumentBody && this.previousActiveElement && this.previousActiveElement.blur) {
            this.previousActiveElement.blur();
        }
        this.$closeBtn.on('click', $.proxy(this.close, this));
        this.$root.show();
        return this;
    };

    /**
     * Hide modal.
     */
    Modal.prototype.close = function () {
        this.$root.hide();
        if (this.previousActiveElement && this.previousActiveElement.focus) {
            this.previousActiveElement.focus();
        }
        this.destroy();
    };

    Modal.prototype.ok = function (callback) {
        var self = this;
        this.handler({
            self: self,
            extraClass: 'modal-ok',
            callback: callback,
            btnText: 'OK'
        });
        return this;
    };

    Modal.prototype.doContinue = function (callback, btnText) {
        var self = this;
        this.handler({
            self: self,
            extraClass: 'modal-continue',
            callback: callback,
            btnText: btnText || 'OK'
        });
        return this;
    };

    /**
     * Set modal title.
     *
     * @param {String} content
     * @returns {Modal}
     */
    Modal.prototype.title = function (content) {
        this.$titleEl.html(content);
        return this;
    };
    Modal.prototype.subTitle = function (content) {
        this.$subTitleEl.html(content);
        return this;
    };

    /**
     * Set modal content.
     *
     * @param {String} content
     * @returns {Modal}
     */
    Modal.prototype.content = function (content) {
        this.$contentEl.html(content);
        return this;
    };

    /**
     * Set modal footer content.
     *
     * @param {String} content
     * @returns {Modal}
     */
    Modal.prototype.footer = function (content) {
        this.$footerEl.html(content).show();
        return this;
    };

    /**
     * Button handler.
     * @param options
     */
    Modal.prototype.handler = function (options) {
        var self = options.self;
        var extraClass = options.extraClass;
        var callback = options.callback;
        this.$typeContainer.addClass(extraClass);
        this.$okBtnText.html(options.btnText);

        if ($.isFunction(callback)) {
            this.$okBtn.on('click', function () {
                callback(self);
            });
            this.$closeBtn.on('click', function () {
                callback(self);
            });
        }
        return this;
    };

    Modal.prototype.removeTitle = function () {
        this.$titleEl.html("");
        this.$subTitleEl.html("");
        this.$contentEl.addClass('modal-no-title-content');
        return this;
    };

    return {
        create: function () {
            var modal = new Modal();

            setTimeout(function () {
                try {
                    var $body = angular.element(document.body);
                    var $rootScope = $body.scope().$root;
                    var deregister = $rootScope.$on('$routeChangeSuccess', function () {
                        modal.close();
                        deregister();
                    });
                } catch (err) {}
            }, 0);

            return modal;
        }
    }
});
